<template>
  <section class="container py-5" style="max-width:720px">
    <h2 class="fw-bold mb-4">Admin</h2>
    <div class="card p-4">
      <p class="mb-3">Enter your admin token to fetch stats.</p>
      <input v-model="token" class="form-control mb-3" type="password" placeholder="x-admin-token" />
      <button class="btn btn-primary" @click="fetchStats">Fetch</button>
      <pre class="mt-3 p-3 rounded bg-body-secondary text-body border" v-if="json">{{ json }}</pre>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
const token = ref(sessionStorage.getItem('adminToken') || '');
const json = ref<string | null>(null);
async function fetchStats() {
  sessionStorage.setItem('adminToken', token.value);
  const res = await fetch('/api/admin/stats', { headers: { 'x-admin-token': token.value }});
  json.value = JSON.stringify(await res.json(), null, 2);
}
</script>
